<template>
  <div class="container">
    <div class="title">订单信息</div>
    <table class="tableList">
      <tr>
        <th>订单编号</th>
        <th>下单时间</th>
        <th>支付时间</th>
        <th>支付方式</th>
      </tr>
      <tr>
        <td>{{ formData.orderNo }}</td>
        <td>{{ formData.payTime | formatDate }}</td>
        <td>{{ formData.gmtCreate }}</td>
        <td>{{ PAY_TYPE[formData.payType] }}</td>
      </tr>
    </table>
    <table class="tableList">
      <tr>
        <th style="border-top: 0">收货人姓名</th>
        <th style="border-top: 0">收货人手机号</th>
        <th style="border-top: 0">收货人地址</th>
      </tr>
      <tr>
        <td>{{ formData.consigneeName }}</td>
        <td>{{ formData.consigneeMobile }}</td>
        <td>
          {{
            formData.consigneeProvince +
            formData.consigneeCity +
            formData.consigneeDistrict +
            formData.consigneeAddress
          }}
        </td>
      </tr>
    </table>
    <div class="title">药品信息</div>
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column type="index" width="50" label="序号"> </el-table-column>
      <el-table-column prop="name" label="药品名称"> </el-table-column>
      <el-table-column prop="drugsSpecs" label="规格"> </el-table-column>
      <el-table-column prop="purchasePrice" label="单价（元）">
      </el-table-column>
      <el-table-column prop="drugNum" label="总量"> </el-table-column>
      <el-table-column prop="packingSpecs" label="单位"> </el-table-column>
      <el-table-column prop="countRetailPrice" label="零售金额（元）">
      </el-table-column>
    </el-table>
    <div class="price">
      <div class="price_item">药品金额：{{ paidPrice }}</div>
      <div class="price_item">快递费用：{{ freightPrice }}</div>
      <div class="price_item">
        合计：<i>{{ actualPaidPrice }}</i>
      </div>
    </div>
    <div class="title">发货信息</div>
    <el-form ref="ruleForm" :model="formData" label-width="80px" :inline="true">
      <el-form-item label="快递公司" prop="shippingCompany">
        <el-select
          v-model="formData.shippingCompany"
          size="small"
          placeholder="请选择快递公司"
        >
          <el-option
            v-for="item in COURIER_COMPANY"
            :key="item.value"
            :label="item.value"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="物流单号" prop="shippingNo">
        <el-input
          v-model="formData.shippingNo"
          size="small"
          placeholder="物流单号"
        />
      </el-form-item>
      <el-form-item label="备注" style="width: 100%">
        <el-input
          v-model="formData.shippingRemark"
          type="textarea"
          placeholder="备注"
          style="width: 600px"
        />
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { pharmacistOrderShippingForm } from "@/api/doctor.js";
import { PAY_TYPE, COURIER_COMPANY } from "@/utils/eum";
export default {
  name: "DrugForm",
  props: {
    isEdit: { type: Number, default: 0 },
    itemList: {
      type: Object,
      default: () => [],
    },
  },
  data() {
    return {
      PAY_TYPE,
      COURIER_COMPANY,
      formData: {},
      tableData: [],
      paidPrice: 0, // 支付价格
      freightPrice: 0, // 运费
      actualPaidPrice: 0, // 实际支付金额
    };
  },
  created() {
    this.paidPrice = this.itemList.paidPrice;
    this.freightPrice = this.itemList.freightPrice;
    this.actualPaidPrice = this.itemList.actualPaidPrice;
    this.formData = this.itemList;
    this.getFormList();
  },
  methods: {
    async getFormList() {
      const res = await pharmacistOrderShippingForm({ id: this.itemList.id });
      this.formData = res.data || {};
      this.tableData = res.data.orderDrugsDrugs;
    },
  },
  filters: {
    /**
     * 格式化日期
     * @param {string | number | Date} value 指定日期
     * @param {string} format 格式化的规则
     * @example
     * ```js
     * formatDate();
     * formatDate(1603264465956);
     * formatDate(1603264465956, "h:m:s");
     * formatDate(1603264465956, "Y年M月D日");
     * ```
     */
    formatDate(value, format = "Y-M-D h:m:s") {
      if (!value) return "";
      const formatList = ["Y", "M", "D", "h", "m", "s"];
      const resultList = [];

      resultList.push(value.substr(0, 4));
      resultList.push(value.substr(4, 2));
      resultList.push(value.substr(6, 2));
      resultList.push(value.substr(8, 2));
      resultList.push(value.substr(10, 2));
      resultList.push(value.substr(12, 2));
      for (let i = 0; i < resultList.length; i++) {
        format = format.replace(formatList[i], resultList[i]);
      }
      return format;
    },
  },
};
</script>
<style lang="scss" scoped>
.el-dialog {
  margin-top: 8vh;
  width: 100%;
}
.title {
  font-size: 16px;
  font-weight: bold;
  margin: 20px 0;
}
.tableList {
  width: 100%;
  text-align: left;
  th {
    border: 1px solid #ebeef5;
    padding: 12px 10px;
    color: #909399;
    background: #fafafa;
  }
  td {
    border: 1px solid #ebeef5;
    padding: 12px 10px;
    color: #606266;
    background-color: #ffffff;
  }
}
.price {
  margin: 20px 0;
  text-align: right;
  &_item {
    margin: 10px 0;
    i {
      font-weight: 700;
    }
  }
}
</style>
